import React, { useState } from 'react';
import { TextField, Button } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';
import { useDispatch } from 'react-redux';
import { registerAction } from '../../actions/loginActions';
import "./Login.css";

function RegisterForm() {
    const history = useHistory();
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            return setError('Passwords do not match');
        }

        if (password.length < 6) {
            return setError('Password must be at least 6 characters long');
        }

        try {
            setError('');
            setLoading(true);
            const result = await dispatch(registerAction(name, email, password));
            if (result.error) {
                setError(result.error);
            } else {
                history.push('/login');
            }
        } catch (error) {
            setError(error.message || 'Failed to register. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="loginForm_main">
            {error && <Alert severity="error" className="error_login">{error}</Alert>}
            <div className="lForm__main">
                <TextField
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="quizForm__textfield"
                    fullWidth
                    id="filled-basic"
                    label="Name"
                    variant="filled"
                />
                <TextField
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="quizForm__textfield"
                    fullWidth
                    id="filled-basic"
                    label="Email"
                    variant="filled"
                />
                <TextField
                    required
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="quizForm__textfield"
                    fullWidth
                    id="filled-basic"
                    label="Password"
                    variant="filled"
                />
                <TextField
                    required
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="quizForm__textfield"
                    fullWidth
                    id="filled-basic"
                    label="Confirm Password"
                    variant="filled"
                />
            </div>
            
            <div className="loginForm__footer">                    
                <Button 
                    onClick={handleSubmit} 
                    className="Register__button"
                    disabled={loading}
                >
                    Register
                </Button>                    
                <div className='loginForm__footerhelper'>
                    <Link to='/login' className='helpLinks'>Already have an account? Login</Link>
                </div>
            </div>
        </div>
    );
}

export default RegisterForm; 